import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["placeholder"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "place_id",
  id: "search-place_id",
  value: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    id: "search-search-form",
    method: "post",
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      name: "search",
      id: "search-box-places",
      autocomplete: "off",
      placeholder: this.placeholderText ?? 'Entrez une ville ou un code postal',
      required: "",
      class: "pac-target-input",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.search) = $event)),
      onClick: _cache[1] || (_cache[1] = ($event: any) => {this.load_libs();}),
      onFocus: _cache[2] || (_cache[2] = ($event: any) => {this.load_libs();})
    }, null, 40, _hoisted_1), [
      [_vModelText, this.search]
    ]),
    _hoisted_2
  ], 32))
}